<template>
  <div>
    <!-- Hidden button to trigger modal -->
    <button
      class="d-none"
      data-toggle="modal"
      data-target="#ShareEventModal"
      ref="openShareModal"
    ></button>

    <!-- Share Modal -->
    <div
      class="modal fade share-event-modal"
      tabindex="-1"
      role="dialog"
      id="ShareEventModal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content p-3">
          <div class="modal-header">
            <h6 class="modal-title m-0">Share Event</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeShareModal"
            >
              <img src="@/assets/Svg/close.svg" />
            </button>
          </div>

          <div class="modal-body text-center">
            <!-- Social Icons -->
          <div class="d-flex justify-content-around mb-3">
  <a href="javascript:void(0)" @click="openWhatsapp" rel="noopener">WhatsApp</a>
  <a href="javascript:void(0)" @click="openFacebook" rel="noopener">Facebook</a>
  <a href="javascript:void(0)" @click="openTwitter" rel="noopener">Twitter</a>
  <a href="javascript:void(0)" @click="openInstagram" rel="noopener">Instagram</a>
</div>

            <!-- URL + Copy -->
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                :value="shareUrl"
                readonly
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="copyUrl"
                >
                  Copy
                </button>
              </div>
            </div>
            <small v-if="copied" class="text-success mt-2 d-block">
              URL copied to clipboard!
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareEvent",
  data() {
    return {
      shareUrl: window.location.href,
      copied: false
    };
  },
  methods: {
    copyUrl() {
      navigator.clipboard.writeText(this.shareUrl).then(() => {
        this.copied = true;
        setTimeout(() => (this.copied = false), 2000);
      });
    },
  isMobile() {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  },
  tryOpenApp(appUrl, webUrl) {
    if (this.isMobile()) {
      const timeout = setTimeout(() => {
        window.open(webUrl, "_blank");
      }, 1000);
      window.location.href = appUrl;
      window.onblur = () => clearTimeout(timeout);
    } else {
      window.open(webUrl, "_blank");
    }
  },
  // WhatsApp
  openWhatsapp() {
    const appUrl = `whatsapp://send?text=${encodeURIComponent(this.shareUrl)}`;
    const webUrl = `https://wa.me/?text=${encodeURIComponent(this.shareUrl)}`;
    this.tryOpenApp(appUrl, webUrl);
  },
  // Facebook
  openFacebook() {
    const url = encodeURIComponent(this.shareUrl);
    const appUrl = `fb://facewebmodal/f?href=${url}`;
    const webUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    this.tryOpenApp(appUrl, webUrl);
  },
  // Twitter
  openTwitter() {
    const appUrl = `twitter://post?message=${encodeURIComponent(this.shareUrl)}`;
    const webUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.shareUrl)}`;
    this.tryOpenApp(appUrl, webUrl);
  },
  // Instagram
  openInstagram() {
    const appUrl = `instagram://`;
    const webUrl = `https://www.instagram.com/`;
    this.tryOpenApp(appUrl, webUrl);
  }
  },
  mounted() {
    this.$root.$on("openShareEventModal", () => {
      const btn = this.$refs.openShareModal;
      if (btn) {
        this.$nextTick(() => {
          btn.click();
        });
      }
    });
  }
};
</script>

<style>
.share-event-modal .modal-content {
  border-radius: 0.5rem !important;
}
</style>
